import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

export function subdomainValidator(
  control: FormControl<string>,
): { subdomainBlank: boolean } | { subdomainPattern: boolean } | null {
  const SUBDOMAIN_PATTERN = /^[0-9a-z]*$/;
  return isEmpty(control.value)
    ? { subdomainBlank: true }
    : SUBDOMAIN_PATTERN.test(control.value)
      ? null
      : { subdomainPattern: true };
}
